export default "__VITE_ASSET__d26bcdca__"